import React, { useState } from "react";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { NbButton, NbInput, NbTextarea } from "../components/nb";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const submit = (e) => {
    e.preventDefault();
    toast.success("Message sent! We'll get back to you soon.");
    setForm({ name: "", email: "", message: "" });
  };
  return (
    <div className="min-h-screen grain">
      <Navbar />
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-12 grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div>
          <div className="inline-block bg-[#D4AF37] nb-border nb-shadow-sm px-3 py-1 mb-4 font-head font-bold text-xs uppercase tracking-widest">Contact</div>
          <h1 className="font-head font-black text-5xl tracking-tighter mb-4">Let's talk.</h1>
          <p className="text-gray-700 font-medium mb-8">Questions, feedback or partnerships — we'd love to hear from you.</p>
          <div className="space-y-4">
            <div className="flex items-center gap-3 bg-white nb-border nb-shadow-sm p-4"><Mail className="w-5 h-5" /> <span className="font-medium">hello@qrcupid.com</span></div>
            <div className="flex items-center gap-3 bg-white nb-border nb-shadow-sm p-4"><Phone className="w-5 h-5" /> <span className="font-medium">+1 (555) 010-2026</span></div>
            <div className="flex items-center gap-3 bg-white nb-border nb-shadow-sm p-4"><MapPin className="w-5 h-5" /> <span className="font-medium">San Francisco, CA</span></div>
          </div>
        </div>
        <form onSubmit={submit} className="bg-white nb-border nb-shadow p-6 space-y-4">
          <div>
            <label className="font-head font-bold text-sm uppercase">Name</label>
            <NbInput data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1" />
          </div>
          <div>
            <label className="font-head font-bold text-sm uppercase">Email</label>
            <NbInput data-testid="contact-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1" />
          </div>
          <div>
            <label className="font-head font-bold text-sm uppercase">Message</label>
            <NbTextarea data-testid="contact-message" required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1" />
          </div>
          <NbButton type="submit" data-testid="contact-submit" className="w-full">Send Message</NbButton>
        </form>
      </section>
      <Footer />
    </div>
  );
}
